<template>
  <b-card>
    <b-row class="mb-4 align-between">
      <b-col>
        <div><strong>{{ trans('my_tickets') }}:</strong></div>
      </b-col>
    <!--   <b-col>
        <b-button variant="link" @click="addTicketsToWallet" size="sm" :disabled="busy" class="p-0 pl-4 mb-2">
          <img :src="trans('google_add_to_wallet_logo')" alt="google add to wallet" style="height:39px">
        </b-button>
        <a v-if="addToAppleWalletLink" :href="addToAppleWalletLink" target="_blank" class="p-0 pl-4 mb-2" download>
          <img :src="trans('apple_add_to_wallet_logo')" alt="apple add to wallet" style="height:39px">
        </a>
      </b-col> -->
    </b-row>
    <b-row>
      <b-col>
        <b-row v-for="(ticket, index) in this.tickets" :key="index">
          <b-col class="col-12 col-sm-9 mb-2" >
            <ticket 
              :ticket="ticket"
              @show-modal="showModal(ticket)"
            ></ticket>
          </b-col>
          <b-col v-if="!ticket.is_old_ticket" class="col-12 col-sm-3 mb-4">
            <button @click="showTransferModal(ticket)" class="btn btn-outline-danger">{{trans('transfer_ticket')}}</button>
          </b-col>
        </b-row>
        <span v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </span>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col class="col-auto">
        <b-button variant="link" @click="addTicketsToWallet" size="sm" :disabled="busy" class="p-0 mb-2">
          <img :src="trans('google_add_to_wallet_logo')" alt="google add to wallet" style="height:39px">
        </b-button>
      </b-col>
      <b-col class="col-auto">
        <a v-if="addToAppleWalletLink" :href="addToAppleWalletLink" target="_blank" class="p-0 mb-2" download>
          <img :src="trans('apple_add_to_wallet_logo')" alt="apple add to wallet" style="height:39px">
        </a>
      </b-col>
    </b-row>
    <ticket-transfer-modal
      ref="transferTicketModal"
      :ticket="selectedTicket"
      :organization="organization"
      @transfered="onTransfered"
    ></ticket-transfer-modal>
    <ticket-modal
      :ticket="selectedTicket" 
    ></ticket-modal>
  </b-card>
</template>


<script>
  import Ticket from './../ticket/Ticket.vue'
  import TicketModal from './../ticket/TicketModal.vue'
  import TicketTransferModal from './../ticket/TicketTransferModal.vue'

  export default {
    props: {
      organization: Object,
      client: Object
    },
    components: {
      Ticket,
      TicketModal,
      TicketTransferModal
    },
    data() {
      return {
        trans: trans,
        lang: lang,
        busy: false,
        error: null,
        tickets: null,
        show_passed: false,
        selectedTicket: null,
      }
    },
    computed: {
      addToAppleWalletLink() {
        return `/org/${this.organization.id}/client/client_event_tickets/download_to_wallet_all/${this.client.id}`
      },
    },
    methods: {
      onTransfered() {
        this.fetch()
      },
      fetch() {
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/client_event_tickets`
        return axios.get(url)
          .then(response => {
            this.busy = false
            this.tickets = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
        })
      },     
      addTicketsToWallet() {
        if (this.organization.id !== 5) return
        this.busy = true
        this.error = null
        let url = `/org/${this.organization.id}/client/client_event_tickets/add_to_wallet_all/${this.client.id}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          if (response.data.jwt) {
            window.open(`https://pay.google.com/gp/v/save/${response.data.jwt}`, '_blank')
          }
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      showModal(ticket) {
        this.selectedTicket = ticket
        this.$bvModal.show('ticket-modal')
      },
      showTransferModal(ticket) {
        this.selectedTicket = ticket
        this.$bvModal.show('ticket-transfer-modal')
      },
    },
    mounted() {
      this.fetch()
    },
  }
</script>